import React from 'react';
import { WidthProvider, Responsive } from 'react-grid-layout'
import TestMap from '../charts-graphs/testMap';
import CarLocateHandler from '../handlers/carLocate-handler';

const ResponsiveGridLayout = WidthProvider(Responsive);

type Layout = {
  i: string; // Unique identifier of the item
  x: number; // X position in grid units
  y: number; // Y position in grid units
  w: number; // Width in grid units
  h: number; // Height in grid units
  minW: number;  // min width in grid units
  minH: number; // min height in grid units
};

const TestGrid: React.FC = () => {

  const layout: Layout[] = [
    { i: 'a', x: 2, y: 1, w: 5, h: 6, minW: 4, minH: 6 },
    { i: 'b', x: 1, y: 7, w: 7, h: 2, minW: 7, minH: 2 },
    { i: 'c', x: 1, y: 12, w: 7, h: 1.5, minW: 7, minH: 1.5 },
  ];

  return (
    <ResponsiveGridLayout 
      className="layout" 
      layouts={{ lg: layout }} 
      breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }} 
      cols={{ lg: 9, md: 6, sm: 4, xs: 2 }}
      rowHeight={100}
      draggableCancel=".cancelSelectorName"
      isDraggable={false}
      isResizable={false}
      >
      <div key="a" style={{ minHeight: "500px" }} className='card-gauge'>
        <TestMap />
        <CarLocateHandler />
      </div>
    </ResponsiveGridLayout>
  );
};

export default TestGrid;